import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../Logo";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { user, logout, role } = useAuth();

  const displayName =
    user?.displayName ||
    user?.name ||
    user?.email?.split("@")[0] ||
    "Account";

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Prevent background scroll on mobile
  useEffect(() => {

  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };

}, [menuOpen]);

  

const goToDashboard = () => {

  const email =
    user?.email?.toLowerCase() || "";

  // STRICT instructor access
  if (
    email.endsWith("@codeion.in")
  ) {

    navigate("/instructor-dashboard");

  }

  // STRICT student access
  else if (
    email.endsWith("@gmail.com")
  ) {

    navigate("/dashboard");

  }

  // Block everything else
  else {

    alert(
      "Access denied"
    );

    navigate("/");

  }

  setMenuOpen(false);
};



const handleLogout = async () => {

  try {

    await logout();

    localStorage.clear();

    sessionStorage.clear();

    setMenuOpen(false);

    navigate("/logout");

  } catch (error) {

    console.error("Logout Error:", error);

  }
};

  return (
    <header className="navbar">
      {/* Logo clickable */}
      <Link to="/" onClick={() => setMenuOpen(false)} className="logo-link">
        <Logo className="nav-logo" />
      </Link>

      {/* Desktop */}
      <nav className="nav-desktop">
        <a
          href="#courses"
          className={location.pathname === "/" ? "active" : ""}
        >
          Courses
        </a>

        <Link
          to="/pricing"
          className={location.pathname === "/pricing" ? "active" : ""}
        >
          Pricing
        </Link>

        <Link
          to="/about"
          className={location.pathname === "/about" ? "active" : ""}
        >
          About
        </Link>

        <Link
  to="/campus-ambassador"
  className={
    location.pathname === "/campus-ambassador"
      ? "active"
      : ""
  }
>
  Careers
</Link>

        {user ? (
          <div className="nav-user">
            <button className="nav-user-link" onClick={goToDashboard}>
              {displayName}
            </button>

            <button
  className="nav-logout"
  onClick={handleLogout}
>
  Logout
</button>
          </div>
        ) : (
          <button
            className="nav-signup"
            onClick={() => navigate("/auth")}
          >
            Get Started
          </button>
        )}
      </nav>

      {/* Mobile */}
      {/* Mobile */}
{!menuOpen && (
  <button className="hamburger" onClick={toggleMenu}>
    <span></span>
    <span></span>
    <span></span>
  </button>
)}

      {menuOpen && (
        <>
          <div
            className="mobile-overlay"
            onClick={toggleMenu}
          ></div>

          <div className="mobile-menu">
            <button className="menu-close" onClick={toggleMenu}>
              ✕
            </button>

            <nav>
              <a href="#courses" onClick={toggleMenu}>
                Courses
              </a>

              <Link to="/pricing" onClick={toggleMenu}>
                Pricing
              </Link>

              <Link to="/about" onClick={toggleMenu}>
                About
              </Link>

              <Link
  to="/careers"
  className={
    location.pathname === "/careers"
      ? "active"
      : ""
  }
>
  Careers
</Link>
            </nav>

            {user ? (
              <div className="menu-user">
                <p>{displayName}</p>

                <button onClick={goToDashboard}>
                  Dashboard
                </button>

                <button onClick={handleLogout}>
                  Logout
                </button>
              </div>
            ) : (
              <button
                className="menu-signup"
                onClick={() => {

  setMenuOpen(false);

  document.body.style.overflow = "";

  navigate("/auth");

}}
              >
                Get Started
              </button>
            )}
          </div>
        </>
      )}
    </header>
  );
}

export default Navbar;